/**
 * The cart bubble is rendered server side with gang sheets counted as sheets, but the
 * live updates from the theme use Shopify's raw item count, which counts decimetres.
 * After every cart update we recount from /cart.js so the badge keeps saying sheets.
 */
const recount = async () => {
  try {
    const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((response) => response.json());
    const count = cart.items.reduce((total, item) => {
      const unit = parseInt(item.properties?._decimeters || '0', 10);
      if (unit > 1 && item.quantity % unit === 0) return total + item.quantity / unit;
      return total + item.quantity;
    }, 0);

    document.querySelectorAll('[ref="cartBubbleCount"]').forEach((element) => {
      element.textContent = count > 0 && count < 100 ? String(count) : '';
      element.classList.toggle('hidden', count === 0);
    });
  } catch {
    // The badge keeps whatever the server rendered.
  }
};

document.addEventListener('cart:update', () => {
  // Let the theme write its own number first, then correct it.
  setTimeout(recount, 0);
});
